import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonKentimaYpsiliRight';
const args = {};

export class OligonKentimaYpsiliRight extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
